import { ENTRY_PATH } from '@/constants/od-session-context'
import { getEntryPath } from '@/utils/get-entry-path/get-entry-path'

export const EXPERIENCE = {
  STARTSCAN: 'StartScan',
  ACTIVATE: 'Activate',
  CONNECT: 'Connect',
  GO: 'Go',
  PN: 'Pn',
} as const

export function getExperienceScreenName(): string {
  const entryPath = getEntryPath()
  switch (entryPath) {
    case ENTRY_PATH.STARTSCAN:
      return EXPERIENCE.STARTSCAN
    case ENTRY_PATH.ACTIVATE:
      return EXPERIENCE.ACTIVATE
    case ENTRY_PATH.GO:
      return EXPERIENCE.GO
    case ENTRY_PATH.PN:
      return EXPERIENCE.PN
    default:
      return EXPERIENCE.CONNECT
  }
}
